/** @jsx jsx */
import { jsx, Image } from 'theme-ui';
import { Link } from 'components/link';

export default function Logo({ src, ...rest }) {
  return (
    <Link
      path="/"
      spy={true}
      smooth={true}
      offset={-70}
      duration={500}
      sx={{
        variant: 'links.logo',
        display: 'flex',
        cursor: 'pointer',
        mr: 15,
        maxWidth: 200
      }}
      {...rest}
    >
      <Image src={src} alt="PT. Pinisi Elektra Logo" />
    </Link>
  );
}
